import { useApiList } from "@/queries/base/useApiList";

/**
 * Fetches the total notification count (non-paginated).
 * GET /notification/count?user_role=X&notifiable_id=Y
 *
 * @param {object} queryParams - Query parameters (user_role, notifiable_id, etc.)
 * @param {any} deps - Additional dependencies that trigger a refetch when changed.
 * @returns {{ data: object|null, isLoading: boolean, error: string|null, refetch: Function }}
 *
 * The returned `data` shape is:
 *   { success: true, count: <int> }
 */
export function useNotificationCount(queryParams = {}, deps = []) {
  const cleanParams = Object.fromEntries(
    Object.entries(queryParams).filter(
      ([, v]) => v !== undefined && v !== null && v !== "",
    ),
  );
  const queryString = new URLSearchParams(cleanParams).toString();
  const resourcePath = `/notification/count?${queryString}`;

  return useApiList(resourcePath, [deps, JSON.stringify(queryParams)]);
}
